import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { CartContext } from "../context/CartContext";
import "./Cart.css";

export default function Cart() {
  const {
    cartItems,
    updateDescription,
    removeFromCart,
    addToCart,
  } = useContext(CartContext);

  const navigate = useNavigate();

  const totalItems = cartItems.reduce(
    (total, item) => total + item.quantity,
    0
  );

  return (
    <div className="cart-page">
      
      {/* STICKY HEADER */}
      <div className="cart-header">
        <h1>Shopping Cart</h1>

        {cartItems.length > 0 && (
          <div className="header-right">
            <span>Subtotal ({totalItems} items)</span>
            <button
              className="checkout-btn"
              onClick={() => navigate("/contact")}
            >
              Place Order
            </button>
          </div>
        )}
      </div>

      <div className="cart-container">

        {cartItems.length === 0 ? (
          <div className="empty-cart">
            Your Cart is Empty
          </div>
        ) : (
          cartItems.map((item, index) => (
            <div key={index} className="cart-card">

              {/* IMAGE */}
              <div
                className="cart-card-image"
                onClick={() =>
                  navigate("/products", {
                   state: { selectedProductId: item._id }
                  })
                }
              >
                <img src={item.image} alt={item.name} />
              </div>

              {/* DETAILS */}
              <div className="cart-card-details">
                <h2>{item.name}</h2>

                <div className="quantity-box">
                  <button onClick={() => removeFromCart(index)}>
                    −
                  </button>

                  <span>{item.quantity}</span>

                  <button
                    onClick={() =>
addToCart({
  _id: item._id,   // 🔥 IMPORTANT
  name: item.name,
  image: item.image,
  specification: item.specification,
})
                    }
                  >
                    +
                  </button>
                </div>

                <textarea
                  placeholder="Add additional specifications..."
                  value={item.specification}
                  onChange={(e) =>
                    updateDescription(index, e.target.value)
                  }
                ></textarea>
              </div>

            </div>
          ))
        )}

      </div>
    </div>
  );
}